import React, { useState, useEffect, useRef } from "react";
import { FiChevronDown } from "react-icons/fi";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";

import ServiceTypeService from "src/Services/API/service.service";

const ServiceTypeDropdown = ({ selectedItem, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [selectedServiceType, setSelectedServiceType] = useState(null);

  useEffect(() => {
    fetchServiceTypes();
  }, []);

  useEffect(() => {
    if (isOpen) {
      fetchServiceTypes();
    }
  }, [isOpen]);

  // ✅ Fetch again when selectedItem changes
  useEffect(() => {
    if (selectedItem) {
      fetchServiceTypes();
    }
  }, [selectedItem]);

  // ✅ Select AFTER the list updates
  useEffect(() => {
    if (!selectedItem || serviceTypes.length === 0) return;

    const match = serviceTypes.find(
      (type) => type.id === selectedItem.id
    );

    if (match) {
      setSelectedServiceType(match);
    }
  }, [serviceTypes, selectedItem]);

  const fetchServiceTypes = async () => {
    const response = await ServiceTypeService.getAllForSelection();
    setServiceTypes(response.data);
  };

  const handleTypeClick = (serviceType) => {
    setSelectedServiceType(serviceType);
    onSelect(serviceType);
    setIsOpen(false);
  };

  return (
    <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
      <div className="relative w-full">
        <div
          data-testid="service-type-select"
          onClick={() => setIsOpen(!isOpen)}
          className="w-full flex items-center h-[30px] justify-between px-4 py-2 border rounded-[6px] cursor-pointer"
        >
          <span className="text-[12px]">
            {selectedServiceType?.serviceType || "Select"}
          </span>
          <FiChevronDown size={15} />
        </div>

        {isOpen && (
          <ul className="absolute z-10 mt-2 w-full bg-white border rounded-md shadow-lg max-h-[160px] overflow-y-auto">
            {serviceTypes.map((serviceType) => (
              <li
                key={serviceType.id}
                data-testid="service-type-option"
                onClick={() => handleTypeClick(serviceType)}
                className={`px-4 py-2 cursor-pointer hover:bg-gray-200 text-[12px]
                  ${selectedServiceType?.id === serviceType.id ? "bg-gray-200" : ""}`}
              >
                {serviceType.serviceType}
              </li>
            ))}
          </ul>
        )}
      </div>
    </OutsideClickHandler>
  );
};



export default ServiceTypeDropdown;
